import React from 'react'

/**
 * Styled text input with optional label, error, and helperText
 * @param {string} label - renders a <label> above the field
 * @param {string} error - renders red border + error message below
 * @param {string} helperText - renders muted text below (only shown when no error)
 * @param {string} id - used to wire label htmlFor
 */
export default function Input({ className = '', label, error, helperText, id, ...props }) {
  const inputId = id || (label ? label.toLowerCase().replace(/\s+/g, '-') : undefined)
  const inputClasses = `block w-full border rounded px-3 py-2 bg-white text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-1 transition ${
    error
      ? 'border-error focus:border-error focus:ring-error'
      : 'border-gray-300 focus:border-primary focus:ring-primary'
  } ${className}`

  return (
    <div className="w-full">
      {label && (
        <label htmlFor={inputId} className="block text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}
      <input id={inputId} className={inputClasses} {...props} />
      {error && <p className="mt-1 text-sm text-error">{error}</p>}
      {!error && helperText && <p className="mt-1 text-sm text-muted">{helperText}</p>}
    </div>
  )
}
